//    Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './App.css'
import Slideshow from './components/Slideshow'
import WelcomeSlide from './slides/WelcomeSlide'
import PrivacySlide from './slides/PrivacySlide'
import FirstStepsSlide from './slides/FirstStepsSlide'
import TagSenseSlide from './slides/TagSenseSlide'
import FileIconsSlide from './slides/FileIconsSlide'
import AIHotkeysSlide from './slides/AIHotkeysSlide'
import PasteAsSlide from './slides/PasteAsSlide'
import NewPlusPlusSlide from './slides/NewPlusPlusSlide'
import WindowOrganizerSlide from './slides/WindowOrganizerSlide'
import NextStepsSlide from './slides/NextStepsSlide'

function App() {
  const slides = [
    <WelcomeSlide key="welcome" />,
    <PrivacySlide key="privacy" />,
    <FirstStepsSlide key="tag" stepId="tag" />,
    <FirstStepsSlide key="find" stepId="find" />,
    <FirstStepsSlide key="comment" stepId="comment" />,
    <TagSenseSlide key="tagsense" />,
    <FileIconsSlide key="fileicons" />,
    <AIHotkeysSlide key="aihotkeys" />,
    <PasteAsSlide key="pasteas" />,
    <NewPlusPlusSlide key="newplusplus" />,
    <WindowOrganizerSlide key="windoworganizer" />,
    <NextStepsSlide key="nextsteps" />,
  ]

  return (
    <div className="app">
      <Slideshow slides={slides} />
    </div>
  )
}

export default App
